import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { RootState } from '&store/store';
import Container from '../../components/container/container.component';
import { ThemeDetailsWrapper } from './themeDetails.styled';
import ThemeImg from '&assets/images/theme.png';
import { themeDetailsActions } from './themeDetails.slice';
import SubmitButton from '../../components/submitButton/submitButton.component';
import { colors } from '&assets/constants/colors';

type ReduxProps = ConnectedProps<typeof connector>;

const ThemeDetailsComponent = (props: ReduxProps) => {
	const { getTheme, theme, loading, setThemeDetails } = props;
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const pk = location.pathname.split('/')[2];
		const sk = location.pathname.split('/')[3];

		if (pk && sk) {
			getTheme({ pk: pk, sk: sk });
		} else {
			navigate('/');
		}
	}, []);

	return (
		<ThemeDetailsWrapper>
			<Container>
				{loading ? (
					<div className="loading-center">
						<CircularProgress size={40} color="inherit" />
					</div>
				) : (
					theme.pk && (
						<div className="content">
							<div className="header">
								<img src={ThemeImg} alt="" className="theme-img" />
								<div className="header-titles">
									<p className="title">{theme?.title}</p>
									<p className="sub-title">{theme?.challenge?.description}</p>
									{/* <div className="additional">
										<p className="additional-item">Applicants</p>
										<p className="additional-item">18-11-2023</p>
									</div> */}
								</div>
							</div>

							<p className="challenge-description">{theme?.summary}</p>

							<p className="theme-description">{theme?.description}</p>

							{/* <SubmitButton
								title="APPLY NOW"
								id="apply-now-btn"
								className="apply-now"
								icon={true}
								iconColor={colors.primary}
								titleClassName="apply-now-title"
								handleClick={() => {
									setThemeDetails({
										selectedTheme: {
											...theme,
											challengeTitle: theme?.challenge?.title,
										},
									});
									navigate('/submit-challenge');
								}}
							/> */}
						</div>
					)
				)}
			</Container>
		</ThemeDetailsWrapper>
	);
};

const mapStateToProps = (state: RootState) => ({
	loading: state.themeDetails.loading,
	theme: state.themeDetails.theme,
});

const mapDispatchToProps = {
	getTheme: themeDetailsActions.getTheme,
	setThemeDetails: themeDetailsActions.setThemeDetails,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const ThemeDetailsComponentRedux = connector(ThemeDetailsComponent);

export { ThemeDetailsComponentRedux as ThemeDetailsComponent };
